import { render, staticRenderFns } from "./question-row-component.vue?vue&type=template&id=1136104b&scoped=true&"
import script from "./question-row-component.vue?vue&type=script&lang=js&"
export * from "./question-row-component.vue?vue&type=script&lang=js&"
import style0 from "./question-row-component.vue?vue&type=style&index=0&id=1136104b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1136104b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VRow,VSelect})
